import React, { useEffect } from "react";
import { NewFeed } from "./components/NewFeed";
import { List } from "@mui/material";
// import { BeverageIcon } from "../../assets/icons/beverage-icon";
import { CategoryNotAvailable } from "../components/CategoryNotAvailable";

// MUI ICON
import {
  Checkroom,
  Chair,
  Devices,
  Luggage,
  AutoAwesome,
  AutoAwesomeOutlined,
  ChairOutlined,
  DevicesOutlined,
  LuggageOutlined,
} from "@mui/icons-material";

import axios from "../../config/axiosConfig";
export const HomeScreen = () => {
  const [currentCategory, setCurrentCategory] = React.useState("for-you");
  useEffect(() => {
    const getUserInfo = async () => {
      try {
        const response = await axios.get("/auth/me", {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        });
        if (response.data.status === "success") {
          localStorage.setItem("user", JSON.stringify(response.data.data));
        }
      } catch (error) {
        console.log(error);
      }
    };
    getUserInfo();
  }, []);

  return (
    <div className="flex flex-col items-center justify-center h-[82.5vh]">
      <List className="h-[7.8vh] flex flex-row max-w-[100vw] text-xs">
        <button
          className="h-fit flex flex-col justify-center items-center w-[20vw]"
          onClick={() => {
            setCurrentCategory("for-you");
          }}
        >
          {currentCategory === "for-you" ? (
            <AutoAwesome
              sx={{
                fontSize: "2rem",
              }}
            />
          ) : (
            <AutoAwesomeOutlined
              sx={{
                fontSize: "2rem",
                color: "gray",
              }}
            />
          )}
          <p className={currentCategory === "for-you" ? "" : "text-gray-400"}>
            For you
          </p>
        </button>
        <button
          className="h-fit flex flex-col justify-center items-center w-[20vw]"
          onClick={() => {
            setCurrentCategory("clothing");
          }}
        >
          {currentCategory === "clothing" ? (
            <Checkroom
              sx={{
                fontSize: "2rem",
              }}
            />
          ) : (
            <Checkroom
              sx={{
                fontSize: "2rem",
                color: "gray",
              }}
            />
          )}
          <p className={currentCategory === "clothing" ? "" : "text-gray-400"}>
            Clothing
          </p>
        </button>
        <button
          className="h-fit flex flex-col justify-center items-center w-[20vw]"
          onClick={() => {
            setCurrentCategory("furniture");
          }}
        >
          {currentCategory === "furniture" ? (
            <Chair
              sx={{
                fontSize: "2rem",
              }}
            />
          ) : (
            <ChairOutlined
              sx={{
                fontSize: "2rem",
                color: "gray",
              }}
            />
          )}
          <p className={currentCategory === "furniture" ? "" : "text-gray-400"}>
            Furniture
          </p>
        </button>
        <button
          className="h-fit flex flex-col justify-center items-center w-[20vw]"
          onClick={() => {
            setCurrentCategory("electronic");
          }}
        >
          {currentCategory === "electronic" ? (
            <Devices
              sx={{
                fontSize: "2rem",
              }}
            />
          ) : (
            <DevicesOutlined
              sx={{
                fontSize: "2rem",
                color: "gray",
              }}
            />
          )}

          <p
            className={currentCategory === "electronic" ? "" : "text-gray-400"}
          >
            Electronic
          </p>
        </button>
        <button
          className="h-fit flex flex-col justify-center items-center w-[20vw]"
          onClick={() => {
            setCurrentCategory("travel");
          }}
        >
          {currentCategory === "travel" ? (
            <Luggage
              sx={{
                fontSize: "2rem",
              }}
            />
          ) : (
            <LuggageOutlined
              sx={{
                fontSize: "2rem",
                color: "gray",
              }}
            />
          )}

          <p className={currentCategory === "travel" ? "" : "text-gray-400"}>
            Travel gear
          </p>
        </button>
      </List>

      <div className="flex-[1] w-full justify-center items-center center flex flex-col overflow-auto">
        {currentCategory === "for-you" ? (
          <List
            sx={{
              width: "100%",
              height: "100%",
            }}
          >
            <NewFeed />
          </List>
        ) : (
          <CategoryNotAvailable />
        )}
      </div>
    </div>
  );
};
